// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1758":"9d48cd3f","8275":"8ceddce5"}[chunkId] + ".chunk.css";
};